// --- START OF FILE: src/App.js ---
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import ThankYouPage from './components/ThankYouPage';
import ApologyPage from './components/ApologyPage';
import NotFoundPage from './components/NotFoundPage';
import MagStripeWriter from './components/MagStripeWriter';
import ClientDataProcessor from './components/ClientDataProcessor';
import Dashboard from './components/Dashboard';
import Settings from './components/Settings';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import NotificationsPage from './components/NotificationsPage';
import ActivityPage from './components/ActivityPage';
import AnalyticsDetailPage from './components/AnalyticsDetailPage';
import ContestsPage from './components/ContestsPage';
import Leaderboard from './components/Leaderboard';
import RewardCapturePage from './components/RewardCapturePage'; // <-- Added import
import { AuthProvider } from './contexts/AuthContext';
import ChakraWrapper from './components/ChakraWrapper';
import ManageTags from './components/ManageTags';
import ManageUsers from './components/ManageUsers';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/apology" element={<ApologyPage />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/claim-reward" element={<RewardCapturePage />} /> {/* <-- Added route */}

          {/* Authentication Routes */}
          <Route
            path="/login"
            element={
              <ChakraWrapper>
                <Login />
              </ChakraWrapper>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <ChakraWrapper>
                <ForgotPassword />
              </ChakraWrapper>
            }
          />
          <Route
            path="/reset-password"
            element={
              <ChakraWrapper>
                <ResetPassword />
              </ChakraWrapper>
            }
          />

          {/* General Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<MainLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/activity" element={<ActivityPage />} />
              <Route path="/analytics" element={<AnalyticsDetailPage />} />
              <Route path="/manage-tags" element={<ManageTags />} />
              <Route path="/contests" element={<ContestsPage />} />

              {/* Specifically Protected Admin Routes */}
              <Route
                element={<ProtectedRoute allowedUids={['YHHq95EEzIgXUcnFzehvM4GCAMH3']} />}
              >
                <Route path="/magstripe-writer" element={<MagStripeWriter />} />
                <Route path="/client-data" element={<ClientDataProcessor />} />
                <Route path="/manage-users" element={<ManageUsers />} />
              </Route>

              {/* Add more general protected routes here */}
            </Route>
          </Route>


          {/* Catch-all Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
// --- END OF FILE: src/App.js ---